import { Body3 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import i18n from '@flatsy/utils/translations'
import clsx from 'clsx'
import React from 'react'
import { useStyles } from './Style'

const ArrowStep1: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.container, classes.step1, 'active')}>
      <img src={FlatsyTheme.image.arrowStep1} className={classes.arrow} alt="arrow" />
      <div className={classes.stepNumber}>
        <Body3 className={classes.stepNumberInner}>1</Body3>
      </div>
      <Body3 className={classes.stepInformation}>
        {i18n.t('deposit_your_documents_please_no_zip_files')}
      </Body3>
    </div>
  )
}

export default ArrowStep1
